import React from "react";
import { useRouteScreenTitle } from "../../../commons/hooks";
import { TableUser } from "./TableUsers";

export const AbmUser = () => {
  useRouteScreenTitle("ABM Usuarios");

  return <TableUser />;
};
